// extracted by mini-css-extract-plugin
export default {"quickLinks":"_1TM_QI3Y","quickLink":"zXRf_rwp","clicked":"_2SwaY2r7"};